module.exports = __webpack_public_path__ + "static/img/product_images_34_h5_zh.0c12ba4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_34_h5_zh.png
// module id = rcPU
// module chunks = 34